var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "otp-layout" } },
    [
      _c("div", { staticClass: "container" }, [
        _c("p", { staticClass: "headline-large gray" }, [
          _vm._v(_vm._s(_vm.$t("otpView.title"))),
        ]),
        _c("p", { staticClass: "text-left text-medium gray mg mg--t-2" }, [
          _vm.isBPCE
            ? _c("span", { staticClass: "margin-bottom-span" }, [
                _vm._v(_vm._s(_vm.$t("otpView.bpce.upper1"))),
              ])
            : _vm.isE2EUserType
            ? _c("span", { staticClass: "margin-bottom-span" }, [
                _vm._v(_vm._s(_vm.$t("otpView.text.upper1"))),
              ])
            : _c("span", { staticClass: "margin-bottom-span" }, [
                _vm._v(_vm._s(_vm.$t("otpView.text.upper"))),
              ]),
          _c("span", { staticClass: "margin-bottom-span" }, [
            _vm._v(_vm._s(_vm.$t("otpView.text.upper2") + _vm.getPhone + ".")),
          ]),
          _c("span", { staticClass: "margin-bottom-span" }, [
            _vm._v(_vm._s(_vm.$t("otpView.text.upper3"))),
          ]),
        ]),
        _c("img", {
          staticClass: "center",
          attrs: { src: require("@/assets/images/self-care/otp.png") },
        }),
        _c("p", { staticClass: "text-medium gray mg mg--t-2" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("otpView.text.lower1")))]),
        ]),
        _c(
          "div",
          { staticClass: "otp-div" },
          [
            _c("ma-otp-input", {
              attrs: { numInputs: _vm.inputsNumber, shouldAutoFocus: true },
              on: { "on-change": _vm.handleOnChange },
            }),
            _c(
              "p",
              {
                staticClass: "p-blue-text-link text-link",
                on: { click: _vm.openInfoModal },
              },
              [
                _c("span", { staticClass: "blueDark" }, [
                  _vm._v(_vm._s(_vm.$t("otpView.text.nocode"))),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("ma-confrim-btn", {
        attrs: {
          handleButtonClick: _vm.handleValidateOtp,
          handleButtonClickWhiteBtn: _vm.handleResendSMS,
          title: _vm.$t("actions.confirmAndContinue"),
          titleWhiteBtn: _vm.$t("otpView.text.resend"),
          mainBlueShouldBeDisabled: _vm.isDisabledButton,
          btnType: _vm.getBtnType,
        },
      }),
      _c(
        "ma-modal",
        {
          ref: "modalInfoOtp",
          staticClass: "modal-confirmation",
          attrs: { type: "small" },
        },
        [
          _c("template", { slot: "modalContent" }, [
            _c("div", { staticClass: "modal__main" }, [
              _c("h1", { staticClass: "title-popup" }, [
                _vm._v(_vm._s(_vm.$t("otpView.text.nocode"))),
              ]),
              _c("p", { staticClass: "popup-first-line" }, [
                _vm._v(_vm._s(_vm.$t("otpView.text.popup.text1"))),
              ]),
              _c("ol", { staticClass: "numbered-list" }, [
                _c("li", { staticClass: "list-item" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("otpView.text.popup.list1_1") +
                        _vm.getPhone +
                        _vm.$t("otpView.text.popup.list1_2")
                    )
                  ),
                ]),
                _c("li", { staticClass: "list-item" }, [
                  _vm._v(_vm._s(_vm.$t("otpView.text.popup.list2"))),
                ]),
                !_vm.isBPCE
                  ? _c("li", { staticClass: "list-item" }, [
                      _vm._v(_vm._s(_vm.$t("otpView.text.popup.list3"))),
                      _c(
                        "a",
                        {
                          staticClass: "blue-text-link",
                          attrs: {
                            href: "https://espace-client.allianz.fr/",
                            target: "_blank",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("otpView.text.popup.link1")))]
                      ),
                    ])
                  : _vm._e(),
                _vm.isBPCE
                  ? _c("li", { staticClass: "list-item" }, [
                      _vm._v(_vm._s(_vm.$t("otpView.text.popup.bpce.text3"))),
                    ])
                  : _vm._e(),
              ]),
              !_vm.isBPCE
                ? _c("p", { staticClass: "popup-line" }, [
                    _vm._v(_vm._s(_vm.$t("otpView.text.popup.text2"))),
                  ])
                : _vm._e(),
            ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }